// modules
import { connect } from 'react-redux';

// data
import { fetchArticleOpenGraph } from 'actions/articles';

// services
import { normalizeUrl } from 'services/string-utils';

// components
import ArticlePreview from 'components/ArticlePreview/ArticlePreview';

export default connect(
  (state, props) => {
    const article = state
      .getIn(['articles', 'all'])
      .find(
        article => normalizeUrl(article.get('url')) === normalizeUrl(props.url)
      );

    return {
      author: article && article.get('author'),
      fetched: state.getIn(['articles', 'fetched']),
      image: article && article.get('image'),
      publisher: article && article.get('publisher'),
      title: article && article.get('title')
    };
  },
  { fetchArticleOpenGraph }
)(ArticlePreview);



// WEBPACK FOOTER //
// ./src/containers/ArticlePreview/ArticlePreview.js